import React, { useRef } from 'react'
import useCardMouseAnimations from 'hooks/useCardMouseAnimations'
import Img from 'components/shared/Image/Img'
import { Title, Text } from 'components/typo'
import classnames from 'classnames/bind'
import css from './styles.module.scss'
import Link from '../Link'

const cx = classnames.bind(css)

const LinkEditoWithImage = ({
  className,
  fullBackground = false,
  title,
  text,
  link,
  icon,
}) => {
  const linkRef = useRef(null)
  const backgroundRef = useRef(null)
  const [_, mouseEvents] = useCardMouseAnimations({
    linkRef,
    backgroundRef,
    span: 0.05,
  })

  const Wrapper = link && link.href ? Link : 'div'
  
return (
  <Wrapper
    ref={linkRef}
    className={cx(className, css.LinkEditoWithImage, { fullBackground })}
    {...link}
    {...mouseEvents}
  >
    {icon && icon.media && (
    <div className={css.icon}>
      <div ref={backgroundRef} className={css.iconBackground} />
      <Img className={css.img} {...icon} />
    </div>
      )}
    <div className={css.textContent}>
      {title && (
      <Title tag="p" className={css.title} size="smaller">
        {title}
      </Title>
        )}
      {text && (
      <Text className={css.text} size="smaller">
        {text}
      </Text>
        )}
    </div>
  </Wrapper>
  )
}

LinkEditoWithImage.defaultProps = {}

export default LinkEditoWithImage
